export default "__VITE_ASSET__Bcsakj3k__"